<template>
  <div 
    v-loading="loading" 
    :style="'height:' + height"
    ref="iframeContainer"
    :class="{ 'fullscreen-mode': isFullscreen }"
  >
    <iframe
      :src="src"
      frameborder="no"
      style="width: 100%; height: 100%"
      scrolling="auto"
      ref="iframe"
    />
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    // 接收全屏状态
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      height: document.documentElement.clientHeight - 336.75 + "px;",
      loading: true,
      url: this.src,
      isFullscreen: this.fullscreen
    };
  },
  watch: {
    fullscreen(val) {
      this.isFullscreen = val;
      if (val) {
        this.enterFullscreen();
      } else {
        this.exitFullscreen();
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 300);
    
    window.addEventListener('resize', this.handleResize);
    this.setupFullscreenListeners();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.removeFullscreenListeners();
  },
  methods: {
    handleResize() {
      if (!this.isFullscreen) {
        this.height = document.documentElement.clientHeight - 336.75 + "px;";
      }
    },
    
    setupFullscreenListeners() {
      document.addEventListener('fullscreenchange', this.onFullscreenChange);
      document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
      document.addEventListener('mozfullscreenchange', this.onFullscreenChange);
      document.addEventListener('MSFullscreenChange', this.onFullscreenChange);
    },
    
    removeFullscreenListeners() {
      document.removeEventListener('fullscreenchange', this.onFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
      document.removeEventListener('mozfullscreenchange', this.onFullscreenChange);
      document.removeEventListener('MSFullscreenChange', this.onFullscreenChange);
    },
    
    onFullscreenChange() {
      const isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
      
      this.isFullscreen = isFullscreen;
      this.$emit('update:fullscreen', isFullscreen);
      
      if (isFullscreen) {
        this.height = '100vh;';
      } else {
        this.height = document.documentElement.clientHeight - 336.75 + "px;";
      }
    },
    
    enterFullscreen() {
      const element = this.$refs.iframeContainer;
      
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }
};
</script>

<style scoped>
.fullscreen-mode {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #fff;
}
</style>